import React, { useEffect, useMemo, useState } from "react";
import DescendingIcon from "../Icons/descending";
import AscendingIcon from "../Icons/ascending";
import Highlighter from "react-highlight-words";
import { copyToClipboard } from "../../utils/clipBoard";
import { useClientTableSort } from "../../hooks/useClientTableSort";
import SortableTh from "../table/SortableTh";

const Table = ({
  headers,
  data,
  filter: _filter,
  order,
  filterParams: _filterParams,
  setFilterParams: _setFilterParams,
  searchText,
}) => {
  const [internalData, setInternalData] = useState(() =>
    Array.isArray(data) ? data : []
  );
  const { headerSort, sortByColumn, resetSort } = useClientTableSort(setInternalData);

  const dataFingerprint = useMemo(
    () =>
      `${(data && data.length) || 0}:${data?.[0] ? JSON.stringify(data[0]) : ""}`,
    [data]
  );

  useEffect(() => {
    if (!order) return;
    setInternalData(Array.isArray(data) ? data : []);
    resetSort();
  }, [order, dataFingerprint, resetSort]);

  const rows = order ? internalData : data ?? [];

  return (
    <table className="w-full">
      <thead className="border-b text-dark-blue-200 bg-white sticky z-1 top-0">
        <tr className="text-center">
          {headers?.map((header, index) =>
            order ? (
              <SortableTh
                key={index}
                label={header.th}
                columnKey={header.key}
                headerSort={headerSort}
                className="px-4 py-2"
                innerLabelClassName="text-xs font-medium leading-normal"
                scope="col"
                onSortDescending={(key) => sortByColumn(key, true)}
                onSortAscending={(key) => sortByColumn(key, false)}
              />
            ) : (
              <th key={index} scope="col" className="px-4 py-2">
                <div className={`flex px-4 gap-1`}>
                  <div className=" text-xs font-medium leading-normal ">
                    {header.th}
                  </div>
                  <div className=" flex items-center w-[31.8px]"></div>
                </div>
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {rows?.length > 0 &&
          rows?.map((item, index) => (
            <tr
              key={index}
              className={`border-b ${
                index % 2 === 1 ? "bg-white" : "bg-light-grey-100"
              } text-center   text-light-grey-400`}
            >
              {headers?.map((header, headerIndex) => (
                <>
                  {header.key === "actions" ? (
                    <td
                      key={header.key}
                      className="px-4 py-3 flex items-center gap-4"
                    >
                      <input type="checkbox" className="" />
                      <img
                        className=" cursor-pointer"
                        src={"/assets/icon-copy.svg"}
                        width={16}
                        alt="Copy"
                        onClick={() => copyToClipboard(rows)}
                      />
                    </td>
                  ) : (
                    <>
                      <td
                        key={headerIndex}
                        className={` font-normal text-medium-grey px-4 py-3 text-[10px] leading-normal `}
                      >
                        <Highlighter
                          highlightClassName="YourHighlightClass"
                          searchWords={[searchText]}
                          autoEscape={true}
                          textToHighlight={
                            `${!item[header.key] ? "" : item[header.key]}` ||
                            "N/A"
                          }
                        />
                        {header.key === "billingConfigurationdropdown" ? (
                          <select
                            id="small"
                            className="block w-[80px] h-[23px] m-auto text-center text-[10px] leading-normal font-normal text-black border border-light-grey-500 rounded-2xl bg-white focus:border-blue-500"
                          >
                            <option selected>Nett</option>
                            <option value="US">Forward</option>
                          </select>
                        ) : (
                          ""
                        )}
                      </td>
                    </>
                  )}
                </>
              ))}
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default Table;
